import { useAxios } from '@/features/common/helpers/axios';
import { StoreForImport } from '@/features/shipment/types';
import { parseError } from '@/features/common/helpers/errorParser';
import { GlobalResponseType } from '@/features/common/types';
import { AddStorePayload, SupportedIntegration } from '../types';

export const { axiosService, baseURL } = useAxios();

export interface AddStoreResponse {
  success: boolean,
  redirectTo?: string,
  platformConnectorList?: StoreForImport[],
}

export const getConnectedStores = async (): Promise<StoreForImport[] | null> => {
  try {
    const res = await axiosService.get('/integrations/connected?ecommOnly=true');
    return res.data;
  } catch {
    return null;
  }
};

export const getSupportedStores = async (): Promise<SupportedIntegration[] | null> => {
  try {
    const res = await axiosService.get('/integrations/supported?ecommOnly=true');
    return res.data;
  } catch {
    return null;
  }
};

export const addStoreConnection = async (
  payload: AddStorePayload,
): Promise<AddStoreResponse | GlobalResponseType> => {
  try {
    const res = await axiosService.post('/integrations/connected', payload);
    return res.data;
  } catch (er) {
    return parseError(er);
  }
};

export const deleteStoreConnection = async (id: string): Promise<boolean> => {
  try {
    const res = await axiosService.delete(`/integrations/connected/${id}`);
    return res.data;
  } catch {
    return false;
  }
};

export const installStoreConnection = async (
  payload: AddStorePayload,
): Promise<{ data?: AddStoreResponse } & GlobalResponseType> => {
  try {
    const res = await axiosService.post('/integrations/connected/callback', payload);
    return {
      successful: true,
      errorMessage: '',
      redirectUrl: '',
      data: res.data,
    };
  } catch (er) {
    return parseError(er);
  }
};
